import { Directive, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { ItemModifier } from '../../api/v1/models/item-modifier';
import { ControlValueAccessor, FormControl, FormGroup, ValidationErrors } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FormModifierItem, ModifierItem } from './modifier-item.interface';
import { ItemModifierGroup } from 'src/app/api/v1/models';

@Directive()
export abstract class ModifierListAbstract<T> implements ControlValueAccessor, OnDestroy {
  @Input() minCount: number = 0;
  @Input() maxCount: number = 0;
  @Input() items: ItemModifier[];
  @Input() isCheckMinMaxRestrictions: boolean;
  @Input() modifierGroup: ItemModifierGroup;

  @Output() changeValue = new EventEmitter();

  totalCount: number = 0;
  form: FormGroup = new FormGroup({});
  private formChangeSub: Subscription;

  abstract getFormData(): T[] | null;
  abstract writeFormValue(formData: T[]): void;

  onChange: any = () => {};
  onTouched: any = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
    setTimeout(() => {
      this.update();
    });
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(obj: T[] | null): void {
    if(!obj) {return}
    this.writeFormValue(obj);
  }

  validate(control: FormControl<ModifierItem[] | null>): ValidationErrors | null {
    const value = control.getRawValue();

    this.totalCount = value ?
      value.reduce((total, currentItem) => total + currentItem.quantity, 0) : 0;

    if (this.totalCount < this.minCount) {
      return {minCount: {actualCount: this.totalCount, requiredCount: this.minCount}}
    }

    return null;
  }

  ngOnDestroy(): void {
    this.formChangeSub?.unsubscribe();
  }

  protected update(): void {
    this.onChange(this.getFormData());
    this.changeValue.emit();
  }

  protected getFormItem(): FormGroup<FormModifierItem> {
    return new FormGroup<FormModifierItem>({
      name: new FormControl('', {nonNullable: true}),
      quantity: new FormControl(0, {nonNullable: true}),
      freeQuantity: new FormControl(0, {nonNullable: true}),
      sku: new FormControl('', {nonNullable: true}),
      prices: new FormControl(null, {nonNullable: true}),
      itemGroupId: new FormControl('', {nonNullable: true}),
    })
  }

  protected isCheckDisabledItem(index: number): boolean {
    return this.isCheckMinMaxRestrictions && !this.items[index].restrictions.maxQuantity;
  }
}
